<template>
  <b-container fluid v-if="abc_curve_context_loaded" class="px-2">
    <b-row>
      <b-col class="text-20 mb-4">
        Curva ABC das vendas dos produtos - Ordenado pelo faturamento
      </b-col>
    </b-row>
    <generic-filter>
      <img slot="image" src="@/assets/period_icon.svg" alt="period_icon">
      <v-select
        id="period-selector"
        slot="options"
        class="origin-selector col pl-2"
        :clearable="false"
        :searchable="false"
        v-model="periodSelected"
        :options="periodOptions"
        @input="updateOrderPeriodContext()"/>
    </generic-filter>
    <date-picker v-if="!isHidden" @date-selected="updateOrderPeriodContext"></date-picker>
  </b-container>
</template>

<script>
import GenericFilter from '@/components/GenericFilter.vue'
import DatePicker from '@/components/DatePicker.vue'

export default {
  mounted() {
    this.periodSelected.code = this.$store.getters.abcPeriodSelectedCode
    this.periodSelected.label = this.periodTextArray[this.abcPeriodSelectedIndex]
  },
  components: {
    GenericFilter,
    DatePicker
  },
  data: () => ({
    periodSelected: {
      code: null,  // mudar tbm no store.js
      label: null
    },
    isHidden: true
  }),
  computed: {
    abc_curve_context_loaded() { return this.$store.getters.abc_curve_context_loaded },

    periodTextArray() { return this.$store.getters.periodTextArray },
    abcPeriodSelectedIndex() { return this.$store.getters.abcPeriodSelectedIndex },
    periodText() { return this.periodTextArray[this.abcPeriodSelectedIndex] },
    periodOptions() {
      return [
        { code: 0, label: this.periodTextArray[0] },
        { code: 1, label: this.periodTextArray[1] },
        { code: 2, label: this.periodTextArray[2] },
        { code: 3, label: this.periodTextArray[3] },
        { code: 4, label: this.periodTextArray[4] },
        { code: 5, label: this.periodTextArray[5] },
        { code: 6, label: this.periodTextArray[6] },
        { code: 7, label: this.periodTextArray[7] },
        { code: 8, label: this.periodTextArray[8] }
      ]
    },
    selectedCurrentPeriod() {
      switch (this.abcPeriodSelectedIndex) {
        case 0:
          return "date_period=1"
        case 1:
          return "date_period=2"
        case 2:
          return "date_period=3"
        case 3:
          return "date_period=4"
        case 4:
          return "date_period=6"
        case 5:
          return "date_period=7"
        case 6:
          return "date_period=8"
        case 7:
          return "date_period=9"
      }
    }
  },
  methods: {
    updateOrderPeriodContext(date) {
      if (this.periodSelected.code === 8 && date === undefined) {
        this.periodSelected = 'Intervalo de Datas'
        this.isHidden = !this.isHidden;
        return
      } else if (this.periodSelected.code !== 8) {
        this.isHidden = true;
      }
      if (date !== undefined) {
        this.$store.commit('updateCommonContext', {
          'url': 'order/dashboard/order_curve_abc_context/',
          'payload': { 
            'period': 8,
            'date_start': date.length === 2 ? date[0] : '',
            'date_end': date.length === 2 ? date[1] : date[0],
          }
        });

        // Gambiarra pro Vue Select acionar o @input
        this.periodSelected = {}

        // Alteracao da Label para as Datas
        this.periodSelected.label = `${date.length === 2 ? this.dateFormat(date[0]) + ' ~ ' + this.dateFormat(date[1]) : this.dateFormat(date[0])}`
      } else {
        this.$store.commit('updateCommonContext', {
          'url': 'order/dashboard/order_curve_abc_context/',
          'payload': { 'period': this.periodSelected.code }
        });
      }
    
      this.$store.commit('updateAbcPeriodSelectedCode', this.periodSelected.code)
    },
    dateFormat(date){
      return `${date.split('-').reverse().join('/')}`;
    }
  },
  watch: {
    periodSelected(_new, _old) {
      let adminCode;
      switch (_new.code) {
        case 0:
          adminCode = 1;
          break;
        case 1:
          adminCode = 2;
          break;
        case 2:
          adminCode = 3;
          break;
        case 3:
          adminCode = 4;
          break;
        case 4:
          adminCode = 6;
          break;
        case 5:
          adminCode = 7;
          break;
        case 6:
          adminCode = 8;
          break;
        case 7:
          adminCode = 9;
          break;
      }
      this.$store.commit('updateAbcAdminPeriod', adminCode)
    }
  }
}
</script>

<style>

</style>
